exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/thiago/Documents/projetos/biblioteco-angular/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/thiago/Documents/projetos/biblioteco-angular/src/assets/layouts/layout4/css/custom.min.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/layouts/layout4/css/custom.min.css
// module chunks = styles